<template>
  <section class="section section4m">
    <div class="section-wrap-m">
      <div class="s4-top">
        <h2 class="s4-title">{{$t('home.s4_1')}}</h2>
        <p class="s4-ps" v-html='$t("home.s4_3")'></p>
        <div class="s4-realize-more">
          <div @click="routerSkip('/program')" class="num-more clearfix"><span class="num-more-text">{{$t('common.more')}}</span><img src="@/assets/images/icon/more-point-right.png" class="more-icon"></div>
        </div>
      </div>
      <div class="s4-bottom s4-product-wrap clearfix">
        <div class="s4-wrap-top rela"  @click="routerSkip('/program/list',item.type)" v-for="(item,index) in list" :key="index">
          <div class="s4-wrap-top-img" :style="{'background-image': 'url('+ item.img +')'}"></div>
          <div class="s4-wrap-text tc" v-show="item.title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
  export default {
    name: 'homeSection2m',
    data () {
      return {
        list:[]
      }
    },
    created () {
      this.getList()
    },
    methods: {
      getList() {
        let list = []
        for(let i = 1; i <= 9; i++){
          if(i != 5){
            list.push({
              title:this.$t('home.s4_0'+(i > 5 ? i-1 : i )),
              img:require('@/assets/images/mockImg/p-s4-'+(i > 5 ? i-1 : i )+'.png'),
              type:(i<= 4? 1 : (i>4 && i <8 ) ? 2 : 3)
            })
          }else{
            list.push({
              title:'',
              img:require('@/assets/images/mockImg/disrun.jpg'),
            })
          }
        }
        this.list = list
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .English{
    .s4-bottom.s4-product-wrap .s4-wrap-top .s4-wrap-text{font-size:.2rem}
  }
  .section-wrap-m
    padding-bottom:1rem;
  .section4m
    padding-top 1rem;background-color #f5f5f5
  .s4-top
    rela();
    .s4-title
      font-size .4rem;color $standardColor
    .s4-ps
      margin-top .15rem;font-size .26rem;color $standardColor
    .num-more
      display block;abso();bottom 0;right 0;width: 1.5rem;height: .6rem;border-bottom .02rem solid #666666;text-align left;line-height .58rem;font-size:.24rem;color:#595757;
      .more-icon
        abso();top 0;bottom 0;right 0;margin: auto;width: .32rem;height: .22rem;
  .s4-bottom
    margin-top .75rem;bottom 1rem
    &.s4-product-wrap
      width: 100%
      .s4-wrap-top
        fl();width:33.3%;border-right: 1px solid #fff;background: #004098;border-bottom: 1px solid #fff;
        &:nth-child(3n){border-right:0}
        .s4-wrap-top-img
          height: 3.3rem;width:100%;background-size:cover;
        .s4-wrap-text
          width: 100%;height: .44rem;font-size .22rem;color #fff;background-color #004098;abso();bottom:0;left:0;border-top-left-radius:.08rem;border-top-right-radius:.08rem;display:flex;justify-content:center;align-items:center;line-height:1

</style>
